export const labels = {
	nextSpreadsTooltip: {
		label: "Label.MobileCreator.CheckNextSpreads.Tooltip",
		default: "Tap here or swipe to check other spreads.",
	},
} as const;
